import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { useLocalization } from 'gatsby-theme-i18n';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby"

const GoodsRotateBanner = () => {

  const { localeKey } = useLocalization();
  const { list } = useStaticQuery(graphql`
  query GoodsRotateBanner {
    list : allGoods(
      filter: {data: {status: {eq: "publish"}}}
      sort: {order: ASC, fields: order}
    ) {
      nodes {
        title { ...localizedContent }
        thumb {
          ...localizedImages
        }
      }
    }
  }
`);
const initialImg = useRef(Math.floor(Math.random() * list.nodes.length));
const rotationTimer = useRef(null);
const [ currentImg, setCurrentImg ] = useState(initialImg.current);
const [ prevImg, setPrevImg ] = useState(initialImg.current);

useEffect(() => {
  rotationTimer.current = setTimeout(() => {
    do{
      initialImg.current = Math.floor(Math.random() * list.nodes.length);
    } while(initialImg.current === currentImg || initialImg.current === prevImg)

    setPrevImg(currentImg);
    setCurrentImg(initialImg.current);

  }, 10000);

  return () => {
    clearTimeout(rotationTimer.current);
  };
},[list.nodes.length,currentImg,prevImg]);


  return (<RotateBannerWrapper>
    {list.nodes.map((item,index) => <GatsbyImage key={`goods_${index}`} className={currentImg === index ? 'active' : ''} image={ getImage(item.thumb[localeKey]) ? getImage(item.thumb[localeKey]) : getImage(item.thumb[`default`])} alt={item.title[localeKey]}/>)}
  </RotateBannerWrapper>);
}
 
export default GoodsRotateBanner;

const RotateBannerWrapper = styled.div`
  width:100%;
  padding-top:100%;
  height:0;
  position:relative;
  background:#FFFFFF;

  > .gatsby-image-wrapper{
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    opacity:0;
    z-index:1;
    transition: opacity .3s;

    &.active{
      opacity:1;
      z-index:2;
    }
  }
`
